import React from 'react';

import ChevronRight from '../../../../components/_ui/_blocks/Icon/IconComponents/ChevronRight';
import Notification from '../Notifications/Notification/Notification';
import Typography from '../../../../components/_ui/_blocks/Typography/Typography';
import Link from '../../../../components/NextJs/Link/Link';

import styles from './TreatmentUnavailable.module.css';

interface Props {
    conditionSlug: string;
}

const TreatmentUnavailable = ({ conditionSlug }: Props) => (
    <div className="space-y-rhythm-xsmall">
        <div className="opacity-30" aria-hidden="true">
            <div className="type-emphasis type-090 leading-none">
                Select quantity
            </div>
            <div className={styles.quantity}>
                <ChevronRight size="xsmall" />
            </div>
        </div>
        <ul className={styles.totals} aria-hidden="true">
            <li>
                <Typography as="div" size="090">Delivery</Typography>
                <Typography as="div" size="080" color="quiet">No delivery methods available</Typography>
            </li>
            <li>
                <Typography as="div" size="090" weight="600">Total</Typography>
            </li>
        </ul>
        <Notification>
            This product is currently unavailable,
            <Link href={`/${conditionSlug}`} className="type-link">Find alternatives here</Link>
        </Notification>
        <div
            className="button button-primary button-size-large button-disabled text-center"
            aria-hidden="true"
        >
            Add To Basket
        </div>
    </div>
);

export default TreatmentUnavailable;
